// extracted by mini-css-extract-plugin
export default {"pageWrap":"Be-z","fullWidth":"Ce-z","heading":"De-z","fullBleed":"Ee-z","hidden":"Fe-z"};